import { h, Component } from 'preact';
import { Provider } from 'unistore/preact';
import createStore from 'unistore';
import cache from '../common/cache';
import Home from './home';
import StyleComponent from './StyleComponent';
import CONSTANTS from '../utils/constants';
import { equalsIgnoreCase } from '../utils/common';

export default class App extends Component {
  constructor(props) {
    super(props);
    const cacheInstance = cache.getInstance(this.props.instanceKey);
    this.store = cacheInstance ? cacheInstance.getData('store') : createStore({});
    const mConfigInput = document.getElementById('mconfig');
    mConfigInput && mConfigInput.parentNode.removeChild(mConfigInput);
    this.containerClass = equalsIgnoreCase(this.props.instanceKey, CONSTANTS.DEFAULT_INSTANCE_KEY)
      ? ''
      : `ptm-wrapper-${this.props.instanceKey}`;
  }

  render() {
    return (
      <Provider store={this.store}>
        <div
          id={'paytm-app'}
          className={`paytm-wrapper ptm-pos-r ${this.containerClass}`}
          ref={wrapperComp => {
            this.wrapperComp = wrapperComp;
          }}
        >
          <Home />
          <StyleComponent containerClass={this.containerClass} />
        </div>
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./components/app.js